import { CartLoaderKey } from './dataloaders/CartLoaderKey';
import { CartsCookie } from './dataloaders/CartsCookie';
import { anonymousUid } from './const';

const defaultCartLoaderKey: CartLoaderKey = {
  cartId: null,
  userId: anonymousUid,
  userType: anonymousUid
};

export const initializeCartsCookie = (): CartsCookie => ({
  COLLECT_AT_STORE: defaultCartLoaderKey,
  HOME_DELIVERY: defaultCartLoaderKey
});

export default initializeCartsCookie;
